import React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "types/store";
import { RouteComponentProps, withRouter } from "react-router-dom";

import { Button, ButtonGroup, Icon, Accordion } from "aible";

import { Modal, Popover, OverlayTrigger, Overlay } from "react-bootstrap";

import LabeledToggle from "components/Inputs/Toggle/Toggle";
import { LineInput } from "components/Inputs/LineInput";
import TextInput from "components/Inputs/TextInput";

import Slider from "rc-slider";

import Tooltip from "components/Inputs/Tooltip";

import ModelSelector from "components/ChatGPT/ModelSelector";
import BlueprintSave from "components/ChatGPT/BlueprintSave";
import BlueprintExport from "components/ChatGPT/BlueprintExport";
import UseCaseTypeSelector from "components/ChatGPT/UseCaseTypeSelector";
import FewShotView from "components/ChatGPT/FewShotView";
import SqlGenerationOptions from "components/ChatGPT/SqlGenerationOptions";
import LineageWarning from "components/ChatGPT/LineageWarning";

import DocumentSelector from "components/LanguageModelArtifact/DocumentSelector";

import DynamicWidthSelector from "components/ChatGPT/DynamicWidthSelector";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import BlueprintSelector from "components/ChatGPT/BlueprintSelector";
import ChatGPTSettings from "components/ChatGPT/ChatGPTSettings";

import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as aibleAnywhereReducer from "containers/AibleAnywhere/reducer";
import { BACKEND_STEP_TYPE_OPTIONS, getBackendStepLabelFromSkillname } from "containers/AibleAnywhere/reducer";
import * as globalReducer from "containers/App/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as reportReducer from "containers/Report/ReportReducer";
import * as viewReducer from "containers/View/reducer";
import * as languagageModelArtifactReducer from "containers/LanguageModelArtifact/reducer";
import * as templateReducer from "containers/Templates/reducer";

import { mapToSelectOption, mapToSelectOptions, selectOnChangeWrapper, selectOnChangeWrapperMulti } from "utils/select";

import { DEFAULT_CACHE_AGE, MODEL_PARAMETERS, ALLOWED_DATASET_AIQ_TOOL_IDS } from "containers/ChatGPT/reducer";

import Select, { components } from "react-select";

import { isEnabled } from "utils/featureFlags";

import styles, { chatGPT } from "./style.module.css";

const AibleAnywhereBuilder = ({ match, className, ...retProps } = {}) => {
  const dispatch = useDispatch();

  const [isShowAutoApplySettings, setIsShowAutoApplySettings] = useState(false);

  const aaId = match?.params?.agentId ?? useSelector((state) => chatGPTReducer.getAgentId(state));
  const aaProject = aaId;

  const setAAProject = (nProject) => dispatch(chatGPTReducer.updateSelectedAAProject(nProject));

  const [userPrompt, setUserPrompt] = useState(undefined);
  const [userGenPrompt, setUserGenPrompt] = useState("How should I hire employees that will maximize my Revenue?");

  const replayPrompts = useSelector((state) => chatGPTReducer.getReplayPrompts(state));

  const [multiModels, setMultiModels] = useState([]);
  const askMultiModels = (multiModels, isDownloadExcel) =>
    dispatch(chatGPTReducer.askMultiModels(multiModels, isDownloadExcel));

  const modelOptions = useSelector((state) => chatGPTReducer.getModelOptions(state));

  const aibleAnywhereProjects = useSelector((state) => aibleAnywhereReducer.getBase(state));
  const updateAibleAnywhereProjects = (aa_projects) => dispatch(aibleAnywhereReducer.updateBase(aa_projects));
  const handleAibleAnywhereSteps = (agent, prompt) => dispatch(chatGPTReducer.handleAibleAnywhereSteps(agent, prompt));

  const saveAibleAnywhere = (aaProject, name) => dispatch(aibleAnywhereReducer.saveAibleAnywhere(aaProject, name));

  const generateAAProject = (genPrompt) => dispatch(aibleAnywhereReducer.generateAAProject(genPrompt));
  const generateAAOutline = (genPrompt) => dispatch(aibleAnywhereReducer.generateAAOutline(genPrompt));
  const generateAAFull = (genPrompt) => dispatch(aibleAnywhereReducer.generateAAFull(genPrompt));
  const generateAAProjectFromOutline = (uPrompt, gProj) =>
    dispatch(aibleAnywhereReducer.generateAAProjectFromOutline(uPrompt, gProj));

  const generateSuggestQuestion = () => dispatch(aibleAnywhereReducer.generateSuggestQuestion());

  const isAALoading = useSelector((state) => aibleAnywhereReducer.getIsLoading(state, "misc"));

  const suggestPrompts = useSelector((state) => aibleAnywhereReducer.getSuggestPrompts(state, "misc"));

  const aaOptions = [
    ...(aibleAnywhereProjects === undefined
      ? []
      : Object.keys(aibleAnywhereProjects).map((a) => ({
          label: "(" + a + ") " + (aibleAnywhereProjects[a]?.name ?? ""),
          value: a
        })))
  ];

  const retPrompt = userPrompt ?? aibleAnywhereProjects?.[aaProject]?.defaultPrompt;

  return (
    <div className={styles.aibleAnywhereSteps}>
      <div className={styles.aibleAnywhereTop}>
        {/*
        <div className={styles.aibleAnywhereBody}>
          <div>{"Select or Create New"}</div>
          <Select
            options={aaOptions}
            placeholder="Select Saved Aible Anywhere"
            onChange={(val) => {
              setAAProject(val?.value);
              if (
                aibleAnywhereProjects[val.value]?.defaultPrompt !== undefined
              ) {
                setUserPrompt(aibleAnywhereProjects[val.value]?.defaultPrompt);
              }
            }}
            value={
              aaProject !== undefined
                ? aaOptions.find((a) => a.value === aaProject?.value)
                : undefined
            }
            isClearable
          />
        </div>
        */}
        {aaProject === undefined && (
          <div className={styles.aaBuildDynamic}>
            <div style={{ fontWeight: "bold" }}>{"Enter Question to Generate AA Project"}</div>
            <div>
              <input
                placeholder="Enter Question"
                onChange={(event) => setUserGenPrompt(event.currentTarget.value)}
                value={userGenPrompt}
                style={{ width: "calc(100% - 20px)" }}
              />
            </div>
            <Button
              style={{ marginTop: "10px" }}
              onClick={() => {
                generateAAFull(userGenPrompt);
                setUserPrompt(userGenPrompt);
              }}
              isLoading={isAALoading}
            >
              {"Generate AA Project"}
            </Button>
            <Button
              style={{ marginLeft: "10px" }}
              onClick={() => {
                generateSuggestQuestion();
              }}
            >
              {"Suggest"}
            </Button>
          </div>
        )}
        {suggestPrompts !== undefined && aaProject === undefined && (
          <div className={styles.aaSuggestPrompts}>
            <div className={styles.aaLarge} style={{ marginTop: "20px" }}>
              {"Suggested Prompts"}
            </div>
            {suggestPrompts.map((sPrompt) => (
              <Button
                onClick={() => {
                  setUserPrompt(sPrompt);
                  setUserGenPrompt(sPrompt);
                }}
                style={{ marginTop: "10px" }}
              >
                {sPrompt}
              </Button>
            ))}
          </div>
        )}
        {aaProject !== undefined && (
          <div>
            <div className={styles.aaSteps}>
              {(aibleAnywhereProjects[aaProject]?.steps ?? []).map((s, i) => (
                <AnywhereStep step={s} index={i} aaId={aaProject} key={i + "_" + s?.maxIndex} userPrompt={userPrompt} />
              ))}
              {(aibleAnywhereProjects[aaProject]?.steps ?? []).length === 0 ? (
                <div className={styles.aaPlanLoading}>
                  {"Generating Full Plan..."}
                  <LoadingIndicator />
                </div>
              ) : (
                <div className={styles.addNewPrompt}>
                  <Button
                    onClick={() =>
                      updateAibleAnywhereProjects({
                        ...(aibleAnywhereProjects ?? {}),
                        [aaProject]: {
                          steps: [
                            ...(aibleAnywhereProjects[aaProject]?.steps ?? []),
                            { Title: "", Type: "NLQ", Prompt: "" }
                          ]
                        }
                      })
                    }
                  >
                    {"+ Add New Step"}
                  </Button>
                </div>
              )}
            </div>

            {/*
            <div className={styles.aaTestPrompt}>
              <div className={styles.aaTestInput}>
                <input
                  placeholder="Enter Prompt"
                  onChange={(event) => setUserPrompt(event.currentTarget.value)}
                  value={retPrompt}
                  style={{ width: "calc(100% - 20px)" }}
                  key={retPrompt}
                />
              </div>
              <Button
                onClick={() =>
                  handleAibleAnywhereSteps(
                    aibleAnywhereProjects[aaProject]?.steps,
                    retPrompt,
                  )
                }
              >
                {"Test Prompt"}
              </Button>
            </div>
            */}
          </div>
        )}
      </div>
      {/*
      <div className={styles.aibleAnywhereFooter}>
        <div>
          <div>{"Name"}</div>
          <input
            onChange={(event) =>
              updateAibleAnywhereProjects({
                ...(aibleAnywhereProjects ?? {}),
                [aaProject]: {
                  ...aibleAnywhereProjects?.[aaProject],
                  name: event.currentTarget.value,
                },
              })
            }
            value={aibleAnywhereProjects?.[aaProject]?.name}
            style={{ width: "300px" }}
          />
        </div>
        <Button
          onClick={() =>
            saveAibleAnywhere(
              aibleAnywhereProjects[aaProject],
              aibleAnywhereProjects?.[aaProject]?.name,
            )
          }
          type="primary"
          style={{ marginLeft: "20px" }}
          disabled={
            (aibleAnywhereProjects[aaProject]?.steps ?? []).length === 0
          }
        >
          {"Save Aible Anywhere"}
        </Button>
      </div>
      */}
    </div>
  );
};

const AnywhereGenerateStep = ({ step = undefined, index = 0, aaId = undefined }) => {
  const dispatch = useDispatch();

  const [newPrompt, setNewPrompt] = useState(undefined);

  const replayPrompts = useSelector((state) => chatGPTReducer.getReplayPrompts(state));
  const updateReplayPrompts = (replayPrompts) => dispatch(chatGPTReducer.updateReplayPrompts(replayPrompts));

  const STEP_TYPE_OPTIONS = [
    { label: "NLQ", value: "NLQ" },
    { label: "Document Summary", value: "Document Summary" },
    { label: "Analytics", value: "Analytics" },
    { label: "Prediction", value: "Prediction" },
    // { label: "What's Changed", value: "What's Changed" },
    { label: "Just Chat", value: "Just Chat" },
    { label: "Attach File", value: "Attach File" },
    { label: "Upload File", value: "Upload File" },
    // { label: "Publish Report to Slack", value: "Publish Report to Slack" },
    // { label: "Deep Research", value: "Deep Research" },
    { label: "Action Tree", value: "Action Tree" }
  ];

  const aibleAnywhereProjects = useSelector((state) => aibleAnywhereReducer.getBase(state));
  const updateAibleAnywhereProjects = (aa_projects) => dispatch(aibleAnywhereReducer.updateBase(aa_projects));

  const setNewStepData = (nStep) =>
    updateAibleAnywhereProjects({
      ...aibleAnywhereProjects,
      [aaId]: {
        ...aibleAnywhereProjects?.[aaId],
        generate_steps: (aibleAnywhereProjects?.[aaId]?.generate_steps ?? []).map((s, i) => (i === index ? nStep : s))
      }
    });

  const datasets = useSelector((state) => homeReducer.getDatasets(state));
  const datasetOptions =
    datasets !== undefined
      ? Object.keys(datasets).map((d) => ({
          label: datasets[d]?.label,
          value: d
        }))
      : [];

  const nexts = useSelector((state) => nextReducer.getBase(state));
  const projectOptions = nexts
    ? Object.keys(nexts)
        .filter((n) => nexts[n]?.projectId !== undefined)
        .map((n) => ({
          label: nexts[n]?.reportLabel,
          value: nexts[n]?.projectId
        }))
    : [];

  return (
    <div>
      <div className={styles.addNewPrompt}>
        <div className={styles.chatSettingsItemHeader}>
          {"Aible Step: " + (index + 1)}
          <ButtonGroup>
            <Button style={{ padding: "3px", marginLeft: "10px" }}>{"Regenerate From Plan"}</Button>
            <Button style={{ padding: "3px", marginLeft: "10px" }}>{"Delete"}</Button>
            <Button style={{ padding: "3px", marginLeft: "10px" }}>{"Add New Step"}</Button>
          </ButtonGroup>
        </div>
        <div className={styles.aaStepOptions}>
          <div style={{ width: "calc(50% - 10px)", marginRight: "10px" }}>
            <div>{"Step Type"}</div>
            <div className={styles.aaSelectOption}>
              <Select
                options={STEP_TYPE_OPTIONS}
                placeholder="Select Step Type"
                value={step?.type !== undefined ? { value: step?.type, label: step?.type } : undefined}
                onChange={(val) => setNewStepData({ ...step, type: val.value })}
              />
            </div>
          </div>
        </div>
        <div>{"Generate Prompt"}</div>
        <textarea
          placeholder="Prompt"
          className={styles.aaTextArea}
          value={step?.gen_prompt}
          onChange={(val) => setNewStepData({ ...step, gen_prompt: val.currentTarget.value })}
        />
        {/*
        <Button
          onClick={() => setIsAddPrompt(false)}
          style={{ padding: "4px" }}
        >
          {"Cancel"}
        </Button>
        <Button
          type="primary"
          onClick={() => {
            updateReplayPrompts([newPrompt, ...replayPrompts]);
            setIsAddPrompt(false);
          }}
          style={{ padding: "4px" }}
        >
          {"Save"}
        </Button>
        */}
      </div>
    </div>
  );
};

export const AnywhereStep = ({
  step = undefined,
  index = 0,
  aaId = undefined,
  userPrompt = undefined,
  isModal = false,
  setStepModal = undefined
}) => {
  const dispatch = useDispatch();

  console.log("AnywhereStep aaid", aaId);

  const [newPrompt, setNewPrompt] = useState(undefined);

  const replayPrompts = useSelector((state) => chatGPTReducer.getReplayPrompts(state));
  const updateReplayPrompts = (replayPrompts) => dispatch(chatGPTReducer.updateReplayPrompts(replayPrompts));

  const currentNextId = useSelector((state) => nextReducer.getCurrentNextId(state)) ?? "new";

  const [NLQSettingsType, updateNLQSettingsType] = useState("SQL");

  const STEP_TYPE_OPTIONS = [
    { label: "NLQ", value: "NLQ" },
    //{ label: "API Endpoint", value: "API Endpoint" },
    { label: "Document Summary", value: "Document Summary" },
    { label: "Analytics", value: "Analytics" },
    { label: "Prediction", value: "Prediction" },
    // { label: "What's Changed", value: "What's Changed" }, Commenting out until we need this for the UI builder/update the UI handler
    { label: "Optimize", value: "Optimize" },
    { label: "Attach File", value: "Attach File" },
    { label: "Upload File", value: "Upload File" },
    // { label: "Publish Report to Slack", value: "Publish Report to Slack" }, Commenting out until we need this for the UI builder/update the UI handler
    // { label: "Deep Research", value: "Deep Research" }, Commenting out until we need this for the UI builder/update the UI handler
    { label: "Just Chat", value: "Just Chat" }
    //{ label: "Action Tree", value: "Action Tree" },
  ];

  const aibleAnywhereProjects = useSelector((state) => aibleAnywhereReducer.getBase(state));
  const updateAibleAnywhereProjects = (aa_projects) => dispatch(aibleAnywhereReducer.updateBase(aa_projects));
  const regenStep = () => dispatch(aibleAnywhereReducer.regenStep(aaId, userPrompt, index));

  const isRegenLoading = useSelector((state) => aibleAnywhereReducer.getIsRegenLoading(state, "misc"));

  const currentModel = useSelector((state) => chatGPTReducer.getModelId(state));

  const setNewStepData = (nStep) =>
    updateAibleAnywhereProjects({
      ...aibleAnywhereProjects,
      [aaId]: {
        ...aibleAnywhereProjects?.[aaId],
        steps: (aibleAnywhereProjects?.[aaId]?.steps ?? []).map((s, i) => (i === index ? nStep : s))
      }
    });

  const deleteStep = () => {
    const nSteps = [...(aibleAnywhereProjects?.[aaId]?.steps ?? [])];
    nSteps.splice(index, 1);

    return updateAibleAnywhereProjects({
      ...aibleAnywhereProjects,
      [aaId]: {
        ...aibleAnywhereProjects?.[aaId],
        steps: nSteps
      }
    });
  };

  const addStep = () => {
    const nSteps = aibleAnywhereProjects?.[aaId]?.steps ?? [];
    const newStep = {
      maxIndex: Math.max(nSteps.map((s) => s?.maxIndex)) ?? 0
    };

    const retSteps = [...nSteps.slice(0, index + 1), newStep, ...nSteps.slice(index + 1)];

    return updateAibleAnywhereProjects({
      ...aibleAnywhereProjects,
      [aaId]: {
        ...aibleAnywhereProjects?.[aaId],
        steps: retSteps
      }
    });
  };

  const datasets = useSelector((state) => homeReducer.getDatasets(state));
  const datasetOptions =
    datasets !== undefined
      ? Object.keys(datasets).map((d) => ({
          label: datasets[d]?.label,
          value: d
        }))
      : [];

  const dateFieldDatasets = useSelector((state) => viewReducer.getDateFieldDatasets(state));

  const whatsChangedDatasetOptions = dateFieldDatasets.map((d) => ({
    label: d?.label,
    value: d?.id
  }));

  const nexts = useSelector((state) => nextReducer.getBase(state));
  const projectOptions = nexts
    ? Object.keys(nexts)
        .filter((n) => nexts[n]?.projectId !== undefined)
        .map((n) => ({
          label: nexts[n]?.reportLabel,
          value: nexts[n]?.projectId
        }))
    : [];

  const artifacts = useSelector((state) => languagageModelArtifactReducer.getArtifactList(state, "CORPUS"));

  const retrievalK = useSelector((state) => chatGPTReducer.getRetrievalK(state));
  const updateRetrievalK = (val) => dispatch(chatGPTReducer.updateRetrievalK(val));
  const parentRetrievalK = useSelector((state) => chatGPTReducer.getRetrievalK(state, undefined, true));

  const retRetrievalK = step?.RetrievalK !== undefined ? step?.RetrievalK : retrievalK;

  const modelId = useSelector((state) => chatGPTReducer.getModelId(state));
  const modelExternalId = useSelector((state) => chatGPTReducer.getModelExternalId(state, modelId));

  const systemPrompt = useSelector((state) => chatGPTReducer.getSystemPrompt(state, true, modelId));

  const maxRetrievalK =
    MODEL_PARAMETERS?.[modelExternalId]?.maxRetrievalK ?? MODEL_PARAMETERS?.["DEFAULTS"]?.maxRetrievalK;
  const defaultRetrievalK =
    MODEL_PARAMETERS?.[modelExternalId]?.defaultRetrievalK ?? MODEL_PARAMETERS?.["DEFAULTS"]?.defaultRetrievalK;

  const maxTokens = useSelector((state) => chatGPTReducer.getMaxTokens(state, undefined, true));
  const maxModelTokens = useSelector((state) => chatGPTReducer.getMaxModelTokens(state, modelId));

  const aSteps = aibleAnywhereProjects?.[aaId]?.steps ?? [];
  let addToPromptOptions = [{ label: "User Prompt", value: "{{prompt}}" }];

  for (let i = 0; i < index; i++) {
    addToPromptOptions.push({ label: "Step " + (i + 1) + " Output", value: "{{step_" + (i + 1) + ".output}}" });
  }

  let artifactOptions = artifacts !== undefined ? artifacts.map((a) => ({ label: a?.name, value: a?.id })) : [];

  for (let i = 0; i < aSteps.length; i++) {
    if (aSteps[i].Type === "Upload File") {
      artifactOptions.unshift({
        label: "Uploaded File from Step: " + (i + 1),
        value: "UPLOADED_FILE_STEP_" + (i + 1)
      });
    }
  }

  const [addPromptSelect, updateAddPromptSelect] = useState(addToPromptOptions?.[0] ?? {});

  const voiceOptions = [
    { label: "None", value: "None" },
    { label: "Response", value: "Response" },
    { label: "Generate Summary", value: "Generate Summary" }
  ];

  const retMaxTokens = step?.MaxTokens ?? maxTokens;

  const stringToSpans = (string) => {
    return string.split(" ").map((word, index) => {
      return <span key={index + "_" + word} className={styles.settingQuestionText}>{`${word} `}</span>;
    });
  };

  const templates = useSelector((state) => templateReducer.getBase(state));
  const templateOptions = Object.keys(templates ?? {})
    .filter((f) => templates[f]?.optimizeSetup !== undefined)
    .map((f) => ({ label: templates[f]?.name, value: templates[f]?.id }));

  const sqlDialectOptions = useSelector((state) => chatGPTReducer.getSqlDialectOptions(state));
  const sqlDialect = useSelector((state) => chatGPTReducer.getSecondarySqlDialect(state));

  const columns = useSelector((state) => chatGPTReducer.getDatasetColumns(state));
  const selectedColumns = useSelector((state) => step?.SecondaryColumns ?? chatGPTReducer.getSecondaryColumns(state));
  const columnsExcluded = useSelector(
    (state) => step?.ColumnsExcluded ?? chatGPTReducer.getSecondaryColumnsExcluded(state)
  );

  const updateSecondaryColumns = (val) => dispatch(chatGPTReducer.updateSecondaryColumns(val));
  const updateColumnsExcluded = (val) => dispatch(chatGPTReducer.updateSecondaryColumnsExcluded(val));

  useEffect(() => {
    if (step?.Type === "NLQ") {
      dispatch(chatGPTReducer.selectBlueprint("CHATAIBLE_SQL"));
    }
    if (step?.DatasetId !== undefined) {
      dispatch(nextReducer.updateDatasetId(currentNextId, step?.DatasetId));
    }
  }, []);

  //console.log("we got artifacts?", artifacts);

  return (
    <div>
      <div className={styles.addNewPrompt} style={{ minHeight: "400px", padding: "0px" }}>
        <div className={styles.chatSettingsItemHeader} style={{ marginBottom: "20px" }}>
          {"Aible Step: " + (index + 1)}
          <ButtonGroup>
            {isModal !== true && (
              <Button style={{ padding: "3px" }} onClick={() => addStep()}>
                {"Add New Step"}
              </Button>
            )}
            <Button
              style={{ padding: "3px" }}
              onClick={() => {
                deleteStep();
                if (isModal && setStepModal !== undefined) {
                  setStepModal(undefined);
                }
              }}
            >
              {"Delete"}
            </Button>
          </ButtonGroup>
        </div>
        {step?.Type !== "Attach File" && step?.Type !== "Upload File" && step?.Type !== "Optimize" && (
          <div>
            <div className={styles.editStepBold}>{"Plan Prompt (Used for Generation)"}</div>
            <div className={styles.aaPlanPrompt} style={{ marginBottom: "10px" }}>
              <input
                value={step?.Plan}
                onChange={(val) => setNewStepData({ ...step, Plan: val.currentTarget.value })}
                className={styles.aaInput}
              />
              <Tooltip
                trigger={step?.Type === undefined || step?.Plan === undefined || step?.Plan === "" ? ["hover"] : []}
                overlay={
                  step?.Type === undefined && (step?.Plan === undefined || step?.Plan === "")
                    ? "Please select a Step Type and create a Plan Prompt to generate this step."
                    : step?.Type === undefined
                      ? "Please select a Step Type to generate this step."
                      : step?.Plan === undefined || step?.Plan === ""
                        ? "Please create a Plan Prompt to generate this step."
                        : ""
                }
              >
                <Button
                  style={{ marginLeft: "10px" }}
                  onClick={() => regenStep()}
                  isLoading={isRegenLoading}
                  disabled={step?.Type === undefined || step?.Plan === undefined || step?.Plan === ""}
                >
                  {"Regenerate Step"}
                </Button>
              </Tooltip>
            </div>
          </div>
        )}
        <div className={styles.aaStepOptions}>
          <div style={{ width: "calc(50% - 10px)", marginRight: "10px" }}>
            <div className={styles.editStepBold}>{"Step Type"}</div>
            <div className={styles.aaSelectOption}>
              <Select
                options={STEP_TYPE_OPTIONS}
                placeholder="Select Step Type"
                value={step?.Type !== undefined ? { value: step?.Type, label: step?.Type } : undefined}
                onChange={(val) => {
                  if (val?.value === "NLQ") {
                    dispatch(chatGPTReducer.selectBlueprint("CHATAIBLE_SQL"));
                  }

                  setNewStepData({ ...step, Type: val.value });
                }}
              />
            </div>
          </div>
          {step?.Type === "NLQ" || step?.Type === "Analytics" ? (
            <div style={{ width: "calc(50% - 10px)", marginLeft: "10px" }}>
              <div className={styles.editStepBold}>{"Dataset"}</div>
              <div className={styles.aaSelectOption}>
                <Select
                  options={datasetOptions}
                  placeholder="Select Dataset"
                  value={
                    step?.DatasetId !== undefined
                      ? datasetOptions?.find((d) => Number(d.value) === Number(step?.DatasetId))
                      : undefined
                  }
                  onChange={(val) => {
                    setNewStepData({ ...step, DatasetId: val.value });

                    dispatch(nextReducer.updateDatasetId(currentNextId, val.value));
                  }}
                />
              </div>
            </div>
          ) : step?.Type === "What's Changed" ? (
            <div style={{ width: "calc(50% - 10px)", marginLeft: "10px" }}>
              <div className={styles.editStepBold}>{"Dataset"}</div>
              <div className={styles.aaSelectOption}>
                <Select
                  options={whatsChangedDatasetOptions}
                  placeholder="Select Dataset"
                  value={
                    step?.DatasetId !== undefined
                      ? whatsChangedDatasetOptions?.find((d) => Number(d.value) === Number(step?.DatasetId))
                      : undefined
                  }
                  onChange={(val) => {
                    setNewStepData({ ...step, DatasetId: val.value });

                    dispatch(nextReducer.updateDatasetId(currentNextId, val.value));
                  }}
                />
              </div>
            </div>
          ) : step?.Type === "Prediction" ? (
            <div style={{ width: "calc(50% - 10px)", marginLeft: "10px" }}>
              <div className={styles.editStepBold}>{"Project (Model)"}</div>
              <div className={styles.aaSelectOption}>
                <Select
                  options={projectOptions}
                  placeholder="Select Model"
                  value={
                    step?.ProjectId !== undefined
                      ? projectOptions?.find((d) => Number(d.value) === step?.ProjectId)
                      : undefined
                  }
                  onChange={(val) => setNewStepData({ ...step, ProjectId: val.value })}
                />
              </div>
            </div>
          ) : step?.Type === "Optimize" ? (
            <div style={{ width: "calc(50% - 10px)", marginLeft: "10px" }}>
              <div className={styles.editStepBold}>{"Agent Template (Optimize)"}</div>
              <div className={styles.aaSelectOption}>
                <Select
                  options={templateOptions}
                  placeholder="Select Agent Template"
                  value={
                    step?.TemplateId !== undefined
                      ? templateOptions?.find((d) => Number(d.value) === step?.TemplateId)
                      : undefined
                  }
                  onChange={(val) => setNewStepData({ ...step, TemplateId: val.value })}
                />
              </div>
            </div>
          ) : step?.Type === "Document Summary" ? (
            <div style={{ width: "calc(50% - 10px)", marginLeft: "10px" }}>
              <div className={styles.editStepBold}>{"Document"}</div>
              <div className={styles.aaSelectOption}>
                <Select
                  options={artifactOptions}
                  placeholder="Select Document"
                  value={
                    step?.ArtifactId !== undefined
                      ? artifactOptions?.find(
                          (d) => Number(d.value) === step?.ArtifactId || d.value === step?.ArtifactId
                        )
                      : undefined
                  }
                  onChange={(val) => setNewStepData({ ...step, ArtifactId: val.value })}
                />
              </div>
            </div>
          ) : (
            <div />
          )}
        </div>
        {step?.Type === "API Endpoint" && (
          <div>
            <div className={styles.editStepBold}>{"API Endpoint"}</div>
            <input
              placeholder="Address"
              value={step?.Title}
              onChange={(val) => setNewStepData({ ...step, Title: val.currentTarget.value })}
              className={styles.aaInput}
            />
          </div>
        )}
        <div className={styles.editStepBold}>{"Title"}</div>
        <input
          placeholder="Title"
          value={step?.Title}
          onChange={(val) => setNewStepData({ ...step, Title: val.currentTarget.value })}
          className={styles.aaInput}
        />
        {step?.Type !== "Attach File" && step?.Type !== "Upload File" && step?.Type !== "Optimize" && (
          <div>
            <div className={styles.editStepBold} style={{ marginTop: "5px" }}>
              {"Prompt"}
            </div>
            <textarea
              placeholder="Prompt"
              className={styles.aaTextArea}
              value={step?.Prompt}
              onChange={(val) => setNewStepData({ ...step, Prompt: val.currentTarget.value })}
            />
            <div className={styles.editStepBold}>{"Add previous steps output or user prompt to prompt"}</div>
            <div className={styles.addToPromptSelect}>
              <div style={{ width: "calc(100% - 132px)", marginRight: "10px" }}>
                <Select
                  options={addToPromptOptions}
                  onChange={(val) => updateAddPromptSelect(val)}
                  value={addPromptSelect}
                />
              </div>
              <Button
                onClick={() => setNewStepData({ ...step, Prompt: (step?.Prompt ?? "") + " " + addPromptSelect?.value })}
              >
                {"Add to Prompt"}
              </Button>
            </div>
          </div>
        )}
        <div className={styles.flexHidePrompt}>
          <input
            type="checkbox"
            onChange={() => setNewStepData({ ...step, HidePrompt: !step?.HidePrompt })}
            checked={step?.HidePrompt === true}
            style={{ marginTop: "0px" }}
          />
          <div className={styles.editStepBold} style={{ marginLeft: "5px" }}>
            {"Hide Prompt in Chat"}
          </div>
        </div>
        {step?.Type !== "Analytics" && (
          <div className={styles.flexHidePrompt}>
            <input
              type="checkbox"
              onChange={() => setNewStepData({ ...step, HideResponse: !step?.HideResponse })}
              checked={step?.HideResponse === true}
              style={{ marginTop: "0px" }}
            />
            <div className={styles.editStepBold} style={{ marginLeft: "5px" }}>
              {"Hide Response in Chat"}
            </div>
          </div>
        )}
        {step?.Type !== "Attach File" && step?.Type !== "Upload File" && step?.Type !== "NLQ" && (
          <div>
            <div className={styles.editStepBold} style={{ marginTop: "20px" }}>
              {"Select Model"}
            </div>
            <div>
              <ButtonGroup>
                <Button
                  onClick={() => setNewStepData({ ...step, ModelId: currentModel })}
                  active={step?.ModelId !== undefined}
                >
                  {"Select Model for Step"}
                </Button>
                <Button
                  onClick={() => setNewStepData({ ...step, ModelId: undefined })}
                  active={step?.ModelId === undefined}
                >
                  {"Use Default Model"}
                </Button>
              </ButtonGroup>
            </div>
            <div style={{ marginTop: "10px" }}>
              <ModelSelector
                updateModelId={(modelId) => {
                  setNewStepData({ ...step, ModelId: modelId });
                }}
                modelId={step?.ModelId}
                isDisabled={step?.ModelId === undefined}
              />
            </div>
          </div>
        )}
        {step?.Type === "Document Summary" && (
          <div style={{ width: "100%", marginTop: "20px" }}>
            <div className={styles.settingFlex}>
              <div className={styles.settingLabelAlignedEnd}>
                <span className={styles.settingQuestionText}>Send up to</span>
                <span className={styles.settingValueText}>
                  {retRetrievalK <= maxRetrievalK ? retRetrievalK : `${retRetrievalK} (CUSTOM)`}
                </span>
                {stringToSpans("text excerpts for summarization")}
              </div>
            </div>
            <div className={styles.simpleSliderHolder}>
              <Slider
                marks={{
                  [parentRetrievalK]: <div className={styles.lineageSliderMark} />,
                  1: "1",
                  [defaultRetrievalK]: defaultRetrievalK,
                  [maxRetrievalK]: maxRetrievalK
                }}
                min={1}
                max={maxRetrievalK}
                included={false}
                trackStyle={{ backgroundColor: "transparent" }}
                handleStyle={{
                  backgroundColor: "#9F85F2",
                  borderColor: "white",
                  boxShadow: "0px 0px 6px 1px rgba(81, 47, 119, 0.35)",
                  zIndex: 100,
                  pointer: "cursor !important"
                }}
                onChange={(val) => setNewStepData({ ...step, RetrievalK: val })}
                value={step?.RetrievalK !== undefined ? step?.RetrievalK : retrievalK}
              />
            </div>
          </div>
        )}
        {isEnabled("agent-voice") && step?.Type !== "Attach File" && step?.Type !== "Upload File" && (
          <div>
            <div className={styles.editStepBold} style={{ marginTop: "20px" }}>
              {"Voice Output"}
            </div>
            <div className={styles.addToPromptSelect}>
              <div style={{ width: "100%" }}>
                <Select
                  options={voiceOptions}
                  value={
                    step?.VoiceSelect !== undefined
                      ? { label: step?.VoiceSelect, value: step?.VoiceSelect }
                      : voiceOptions?.[0]
                  }
                  onChange={(val) => setNewStepData({ ...step, VoiceSelect: val.value })}
                />
              </div>
            </div>
          </div>
        )}
        {step?.Type === "NLQ" && (
          <div style={{ marginTop: "20px" }}>
            <ButtonGroup>
              <Button active={NLQSettingsType === "SQL"} onClick={() => updateNLQSettingsType("SQL")}>
                {"SQL Generation"}
              </Button>
              <Button active={NLQSettingsType === "LLM"} onClick={() => updateNLQSettingsType("LLM")}>
                {"LLM Summarization"}
              </Button>
            </ButtonGroup>
            {NLQSettingsType === "SQL" ? (
              <div>
                <div>
                  <div className={styles.editStepBold} style={{ marginTop: "20px" }}>
                    {"SQL LLM Model"}
                  </div>
                  <div style={{ marginTop: "10px" }}>
                    <ModelSelector
                      updateModelId={(modelId) => {
                        setNewStepData({ ...step, SQL_ModelId: modelId });
                      }}
                      modelId={step?.SQL_ModelId}
                    />
                  </div>
                </div>
                <div className={styles.optionItemSelectorHeading} style={{ justifyContent: "flex-start" }}>
                  <div
                    className={styles.chatSettingsItemHeader}
                    style={{ marginBottom: "-2px", marginRight: "5px", minWidth: "250px" }}
                  >
                    {"SQL Dialect"}
                  </div>
                  <DynamicWidthSelector
                    options={sqlDialectOptions}
                    value={sqlDialectOptions?.find(
                      (s) => s?.value === (step?.SecondarySQLDialect ?? sqlDialect ?? "PostgreSQL")
                    )}
                    onChange={selectOnChangeWrapper((val) => setNewStepData({ ...step, SecondarySQLDialect: val }))}
                    style={{
                      width: "200px"
                    }}
                  />
                </div>
                <div className={styles.optionItemSelectorHeading} style={{ justifyContent: "flex-start" }}>
                  <div
                    className={styles.chatSettingsItemHeader}
                    style={{ marginBottom: "-2px", marginRight: "5px", minWidth: "250px" }}
                  >
                    {"Column Values To Include"}
                  </div>
                  <DynamicWidthSelector
                    options={mapToSelectOptions(columns)}
                    value={mapToSelectOption(selectedColumns)}
                    onChange={selectOnChangeWrapperMulti((val) => {
                      console.log("what is val", val);
                      setNewStepData({ ...step, SecondaryColumns: val });

                      return updateSecondaryColumns(val);
                    })}
                    isMulti
                    style={{
                      width: "200px"
                    }}
                  />
                </div>
                <div className={styles.optionItemSelectorHeading} style={{ justifyContent: "flex-start" }}>
                  <div
                    className={styles.chatSettingsItemHeader}
                    style={{ marginBottom: "-2px", marginRight: "5px", minWidth: "250px" }}
                  >
                    {"Column Values To Ignore"}
                  </div>
                  <DynamicWidthSelector
                    options={mapToSelectOptions(columns)}
                    value={mapToSelectOption(columnsExcluded)}
                    onChange={selectOnChangeWrapperMulti((val) => {
                      setNewStepData({ ...step, ColumnsExcluded: val });

                      return updateColumnsExcluded(val);
                    })}
                    isMulti
                    style={{
                      width: "200px"
                    }}
                  />
                </div>
                <div>
                  <div className={styles.editStepBold} style={{ marginTop: "5px" }}>
                    {"SQL Generation Prompt"}
                  </div>
                  <textarea
                    placeholder="Prompt"
                    className={styles.aaTextArea}
                    value={
                      step?.PromptSQL !== undefined
                        ? step?.PromptSQL
                        : chatGPTReducer?.DEFAULT_SECONDARY_SETTINGS?.prompt
                    }
                    onChange={(val) => setNewStepData({ ...step, PromptSQL: val.currentTarget.value })}
                  />
                </div>
              </div>
            ) : NLQSettingsType === "LLM" ? (
              <div>
                <div>
                  <div className={styles.editStepBold} style={{ marginTop: "20px" }}>
                    {"AI Model"}
                  </div>
                  <div style={{ marginTop: "10px" }}>
                    <ModelSelector
                      updateModelId={(modelId) => {
                        setNewStepData({ ...step, ModelId: modelId });
                      }}
                      modelId={step?.ModelId}
                      isDisabled={step?.ModelId === undefined}
                    />
                  </div>
                </div>
                <div>
                  <div className={styles.editStepBold} style={{ marginTop: "20px" }}>
                    {"User Question Instructions"}
                  </div>
                  <textarea
                    placeholder="Prompt"
                    className={styles.aaTextArea}
                    value={step?.SystemPrompt_LLM !== undefined ? step?.SystemPrompt_LLM : systemPrompt}
                    onChange={(val) => setNewStepData({ ...step, SystemPrompt_LLM: val.currentTarget.value })}
                  />
                </div>
              </div>
            ) : (
              <div />
            )}
          </div>
        )}
        {/*
        <Button
          onClick={() => setIsAddPrompt(false)}
          style={{ padding: "4px" }}
        >
          {"Cancel"}
        </Button>
        <Button
          type="primary"
          onClick={() => {
            updateReplayPrompts([newPrompt, ...replayPrompts]);
            setIsAddPrompt(false);
          }}
          style={{ padding: "4px" }}
        >
          {"Save"}
        </Button>
        */}
      </div>
      {step?.Type === "Action Tree" && (
        <div className={styles.aaActionTree}>
          {"Actions"}
          {step.Actions &&
            step.Actions.map((action) => (
              <div>
                <textarea
                  placeholder="Prompt"
                  className={styles.aaTextAreaSmall}
                  value={action?.Text}
                  onChange={(val) =>
                    setNewStepData({
                      ...step,
                      Prompt: val.currentTarget.value
                    })
                  }
                />
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export const AnywhereExecutionStep = ({
  step = undefined,
  index = 0,
  agent = undefined,
  userPrompt = undefined,
  isModal = false,
  setStepModal = undefined,
  isNoMinHeight = false,
  slackChannels = undefined,
  updateWorkflowSource,
  initialChannelTargets,
  initialSandbox
}) => {
  const dispatch = useDispatch();

  console.log("AnywhereStep aaid", agent?.id);

  const aibleAnywhereProjects = useSelector((state) => aibleAnywhereReducer.getBase(state));
  const updateAibleAnywhereProjects = (aa_projects) => dispatch(aibleAnywhereReducer.updateBase(aa_projects));

  const setNewStepData = (nStep) => {
    // Clear out document or dataset info when tool switching
    if (nStep?.tool?.id !== agent?.execution_steps?.[index]?.tool?.id) {
      const updatedInputArgs = {
        ...nStep?.input_args
      };

      let shouldClearArtifact = false;
      if (nStep?.tool?.id !== 1 && updatedInputArgs.doc_id) {
        delete updatedInputArgs.doc_id;
        shouldClearArtifact = true;
      } else if (!ALLOWED_DATASET_AIQ_TOOL_IDS.includes(nStep?.tool?.id) && updatedInputArgs?.dataset_id) {
        delete updatedInputArgs.dataset_id;
        shouldClearArtifact = true;
      }

      if (shouldClearArtifact) {
        const newStep = {
          ...nStep,
          input_args: updatedInputArgs
        };

        if (updateWorkflowSource !== undefined) {
          return updateWorkflowSource({
            ...agent,
            execution_steps: (agent?.execution_steps ?? []).map((s, i) =>
              i === index ? { ...newStep, id: `step_${i}` } : s
            )
          });
        }

        return updateAibleAnywhereProjects({
          ...aibleAnywhereProjects,
          [agent?.id]: {
            ...aibleAnywhereProjects?.[agent?.id],
            execution_steps: (aibleAnywhereProjects?.[agent?.id]?.execution_steps ?? []).map((s, i) =>
              i === index ? { ...newStep, id: `step_${i}` } : s
            )
          }
        });
      }
    }

    if (updateWorkflowSource !== undefined) {
      return updateWorkflowSource({
        ...agent,
        execution_steps: (agent?.execution_steps ?? []).map((s, i) => (i === index ? { ...nStep, id: `step_${i}` } : s))
      });
    }

    updateAibleAnywhereProjects({
      ...aibleAnywhereProjects,
      [agent?.id]: {
        ...aibleAnywhereProjects?.[agent?.id],
        execution_steps: (aibleAnywhereProjects?.[agent?.id]?.execution_steps ?? []).map((s, i) =>
          i === index ? { ...nStep, id: `step_${i}` } : s
        )
      }
    });
  };

  const deleteStep = () => {
    const nSteps = updateWorkflowSource
      ? [...(agent?.execution_steps ?? [])]
      : [...(aibleAnywhereProjects?.[agent?.id]?.execution_steps ?? [])];

    // Update step deletion to cascade delete the input_sources as well to go along with step index id reassignment.
    const stepsUpdate = nSteps
      .map((step, i) => {
        if (i === index) {
          return undefined;
        }

        if (i > index) {
          const stepInputSources = step?.input_sources ?? [];
          const inputSourcesUpdate = stepInputSources
            .map((source) => {
              const sourceStepIndex = source?.startsWith("step_") && Number(source.slice("step_"?.length));
              if (!sourceStepIndex) {
                return source;
              }
              if (sourceStepIndex < index) {
                return source;
              }
              if (sourceStepIndex === index) {
                return undefined;
              }
              return `step_${sourceStepIndex - 1}`;
            })
            .filter((s) => s);

          return { ...step, input_sources: inputSourcesUpdate };
        }

        return step;
      })
      .filter((s) => s);

    // Call to reassign the new step ids based on their index.
    const retStepsUpdate = checkAndUpdateStepIds(stepsUpdate);

    if (updateWorkflowSource !== undefined) {
      return updateWorkflowSource({
        ...agent,
        execution_steps: retStepsUpdate
      });
    }

    return updateAibleAnywhereProjects({
      ...aibleAnywhereProjects,
      [agent?.id]: {
        ...aibleAnywhereProjects?.[agent?.id],
        execution_steps: retStepsUpdate
      }
    });
  };

  // Function to rewrite the step ids using their new index, mostly applies after deleting or reordering steps.
  const checkAndUpdateStepIds = (newSteps) => {
    const updatedSteps = newSteps.map((step, index) => {
      return {
        ...step,
        id: `step_${index}`
      };
    });

    return updatedSteps;
  };

  const addStep = () => {
    const nSteps = updateWorkflowSource
      ? [...(agent?.execution_steps ?? [])]
      : [...(aibleAnywhereProjects?.[agent?.id]?.execution_steps ?? [])];
    const newStep = {
      id: `step_${index}`,
      tool: null,
      type: "tool",
      input_args: null,
      input_sources: [],
      input_template: "",
      communication_tool: null
    };

    const retSteps = [...nSteps, newStep];

    if (updateWorkflowSource !== undefined) {
      return updateWorkflowSource({
        ...agent,
        execution_steps: retSteps
      });
    }

    return updateAibleAnywhereProjects({
      ...aibleAnywhereProjects,
      [agent?.id]: {
        ...aibleAnywhereProjects?.[agent?.id],
        execution_steps: retSteps
      }
    });
  };

  const datasets = useSelector((state) => viewReducer.getDatasets(state));
  const datasetOptions =
    datasets !== undefined
      ? datasets.map((d) => ({
          label: d?.label,
          value: d?.id
        }))
      : [];

  const nexts = useSelector((state) => nextReducer.getBase(state));
  const projectOptions = nexts
    ? Object.keys(nexts)
        .filter((n) => nexts[n]?.projectId !== undefined)
        .map((n) => ({
          label: `${nexts[n]?.reportLabel} (${nexts[n]?.projectId})`,
          value: nexts[n]?.projectId
        }))
    : [];

  const artifacts = useSelector((state) => languagageModelArtifactReducer.getArtifactList(state, "CORPUS"));

  let addToPromptOptions = [{ label: "User Prompt", value: "{{prompt}}" }];

  for (let i = 0; i < index; i++) {
    addToPromptOptions.push({ label: "Step " + (i + 1) + " Output", value: "{{step_" + (i + 1) + ".output}}" });
  }

  let artifactOptions = artifacts !== undefined ? artifacts.map((a) => ({ label: a?.name, value: a?.id })) : [];

  //console.log("we got artifacts?", artifacts);

  console.log("artifactOptions", artifactOptions);

  const blueprints = useSelector((state) => viewReducer.getChatBlueprints(state));
  const isOpenShellOrigin = agent?.workflowOrigin === "OPENSHELL";
  const agentIQToolOptions = useSelector((state) =>
    isOpenShellOrigin
      ? chatGPTReducer.getAgentIQToolOptions(undefined, undefined, undefined, true)
      : chatGPTReducer.getAgentIQToolOptions(undefined, undefined, true)
  );

  const newBackendStepTypeOptions = [...(agentIQToolOptions ?? []), { label: "Synthesize", value: "synthesize" }];

  const foundToolByName = agentIQToolOptions.find((t) => t?.value === step?.tool_name);
  const stepTool = step?.tool;

  const foundToolById = agentIQToolOptions.find((t) => t?.id === stepTool?.id);
  const isSynthesisStep = step?.type === "synthesize";

  const foundTool = isOpenShellOrigin
    ? isSynthesisStep
      ? newBackendStepTypeOptions?.find((o) => o?.value === "synthesize")
      : foundToolById
        ? foundToolById
        : null
    : foundToolByName === undefined
      ? (agent?.tool_list ?? []).find((t) => t.name === step?.tool_name)
      : (agent?.tool_list ?? []).find((t) => Number(t.id) === Number(foundToolByName?.id));
  const foundToolDefaultBlueprint = (blueprints ?? []).find((b) => b?.id === foundTool?.blueprint_id);

  const isExecuteOpenClawTool = foundTool?.id === 20;

  const dateFieldDatasets = useSelector((state) => viewReducer.getDateFieldDatasets(state));

  const whatsChangedDatasetOptions = dateFieldDatasets.map((d) => ({
    label: `${d?.label} (${d?.id})`,
    value: d?.id
  }));

  return (
    <div>
      <div
        className={styles.addNewPrompt}
        style={isNoMinHeight === true ? {} : { minHeight: "460px", padding: "10px 1px" }}
      >
        <div className={styles.chatSettingsItemHeader} style={{ marginBottom: "20px" }}>
          {"Aible Step: " + (index + 1)}
          <ButtonGroup>
            {isModal !== true && (
              <Button style={{ padding: "3px" }} onClick={() => addStep()}>
                {"Add New Step"}
              </Button>
            )}
            <div className={"flex items-center"}>
              <Button
                style={{ padding: "5px 10px", marginRight: "10px" }}
                onClick={() => {
                  deleteStep();
                  if (isModal && setStepModal !== undefined) {
                    setStepModal(undefined);
                  }
                }}
              >
                {"Delete"}
              </Button>
              <div className={"text-[14px] text-[#DC2626] font-normal"}>
                {"Notice: Please verify your step prompts after deleting steps."}
              </div>
            </div>
          </ButtonGroup>
        </div>
        <div className={styles.aaExecutionStepOptions}>
          <div style={{ width: "50%" }}>
            <div className={styles.editStepBold}>{"Step Type"}</div>
            <div className={styles.aaSelectOption}>
              <Select
                options={isOpenShellOrigin ? newBackendStepTypeOptions : BACKEND_STEP_TYPE_OPTIONS}
                placeholder="Select Step Type"
                value={
                  isOpenShellOrigin
                    ? foundTool
                    : step?.tool_name !== undefined
                      ? agentIQToolOptions.find((o) => o?.id === step?.tool_name)
                      : undefined
                }
                onChange={(val) => {
                  if (val?.value === "synthesize") {
                    return setNewStepData({ ...step, tool: null, type: val?.value });
                  }
                  return setNewStepData({ ...step, tool: { id: val?.id }, type: "tool" });
                }}
                isOptionDisabled={(option) => !isExecuteOpenClawTool && option.id === 20}
                isDisabled={isOpenShellOrigin ? foundTool?.id === 20 : undefined}
              />
            </div>
          </div>
          {isExecuteOpenClawTool && (
            <div className={"mb-[16px]"}>
              <div className={styles.editStepBold}>{"OpenClaw Skill"}</div>
              <div>{getBackendStepLabelFromSkillname(step?.input_args?.skill_name)}</div>
            </div>
          )}
          {isSynthesisStep ? (
            <React.Fragment />
          ) : foundTool?.value === "dataset_nlq" || foundTool?.value === "analyze_dataset" ? (
            <div>
              <div style={{ width: "50%" }}>
                <div className={styles.editStepBold}>{"Dataset"}</div>
                <div className={styles.aaSelectOption}>
                  <Select
                    options={datasetOptions}
                    placeholder="Select Dataset"
                    value={
                      step?.input_args?.dataset_id !== undefined
                        ? datasetOptions?.find((d) => Number(d.value) === Number(step?.input_args?.dataset_id))
                        : null
                    }
                    onChange={(val) =>
                      setNewStepData({ ...step, input_args: { ...step?.input_args, dataset_id: val.value } })
                    }
                  />
                </div>
              </div>
              <div style={{ width: "50%" }}>
                <div className={styles.editStepBold}>{"Agent Template"}</div>
                <div className={styles.aaSelectOption}>
                  <BlueprintSelector
                    onChange={(val) => setNewStepData({ ...step, tool: { ...step?.tool, blueprint_id: val.value } })}
                    value={step?.tool?.blueprint_id ?? foundToolDefaultBlueprint?.id}
                  />
                </div>
              </div>
            </div>
          ) : foundTool?.value === "whats_changed" ? (
            <div>
              <div style={{ width: "50%" }}>
                <div className={styles.editStepBold}>{"Dataset"}</div>
                <div className={styles.aaSelectOption}>
                  <Select
                    options={whatsChangedDatasetOptions}
                    placeholder="Select Dataset"
                    value={
                      step?.input_args?.dataset_id !== undefined
                        ? whatsChangedDatasetOptions?.find(
                            (d) => Number(d.value) === Number(step?.input_args?.dataset_id)
                          )
                        : null
                    }
                    onChange={(val) =>
                      setNewStepData({ ...step, input_args: { ...step?.input_args, dataset_id: val.value } })
                    }
                  />
                </div>
              </div>
              {/* <div style={{ width: "50%" }}>
                <div className={styles.editStepBold}>{"Agent Template"}</div>
                <div className={styles.aaSelectOption}>
                  <BlueprintSelector
                    onChange={(val) =>
                      dispatch(aibleAnywhereReducer.updateBlueprintIdForTool(aaId, step?.tool_name, val?.value))
                    }
                    value={foundBlueprint?.id}
                  />
                </div>
              </div> */}
            </div>
          ) : foundTool?.value === "prediction_tool" ? (
            <div>
              <div style={{ width: "50%" }}>
                <div className={styles.editStepBold}>{"Project (Model)"}</div>
                <div className={styles.aaSelectOption}>
                  <Select
                    options={projectOptions}
                    placeholder="Select Model"
                    value={
                      step?.input_args?.project_id !== undefined
                        ? projectOptions?.find((d) => Number(d.value) === step?.input_args?.project_id)
                        : null
                    }
                    onChange={(val) =>
                      setNewStepData({ ...step, input_args: { ...step?.input_args, project_id: val.value } })
                    }
                  />
                </div>
              </div>
            </div>
          ) : foundTool?.value === "summarize_document" ? (
            <div>
              <div style={{ width: "50%" }}>
                <div className={styles.editStepBold}>{"Document"}</div>
                <div className={styles.aaSelectOption}>
                  <Select
                    options={artifactOptions}
                    placeholder="Select Document"
                    value={
                      step?.input_args?.doc_id !== undefined
                        ? artifactOptions?.find(
                            (d) =>
                              Number(d.value) === Number(step?.input_args?.doc_id) ||
                              d.value === step?.input_args?.doc_id
                          )
                        : null
                    }
                    onChange={(val) =>
                      setNewStepData({ ...step, input_args: { ...step?.input_args, doc_id: val.value } })
                    }
                  />
                </div>
              </div>
              <div style={{ width: "50%" }}>
                <div className={styles.editStepBold}>{"Agent Template"}</div>
                <div className={styles.aaSelectOption}>
                  <BlueprintSelector
                    onChange={(val) => setNewStepData({ ...step, tool: { ...step?.tool, blueprint_id: val.value } })}
                    value={step?.tool?.blueprint_id ?? foundToolDefaultBlueprint?.id}
                  />
                </div>
              </div>
              {/*<ChatGPTSettings isForceShowSettings={true} /> */}
            </div>
          ) : (
            <div />
          )}
          <BackendStepPromptOptions step={step} index={index} agent={agent} setNewStepData={setNewStepData} />
          <StepCommunicationOptions
            step={step}
            index={index}
            agent={agent}
            setNewStepData={setNewStepData}
            slackChannels={slackChannels}
            initialChannelTargets={initialChannelTargets}
            initialSandbox={initialSandbox}
          />
        </div>
      </div>
    </div>
  );
};

const BackendStepPromptOptions = ({ step, index, agent, setNewStepData }) => {
  const executionSteps = agent?.execution_steps ?? [];

  const stepSourceOptions = executionSteps
    .map((s, i) => {
      if (i >= index) {
        return undefined;
      }

      return {
        label: `{${s?.id}}: Agent Step ${i + 1}`,
        value: s?.id
      };
    })
    .filter((s) => s);

  const userPromptOption = {
    label: "{user_prompt}: User Prompt",
    value: "user_prompt"
  };

  stepSourceOptions.push(userPromptOption);

  const stepInputSources = step?.input_sources;

  for (const source of stepInputSources ?? []) {
    const foundStepSource = stepSourceOptions?.find((o) => o?.value === source);
    if (!foundStepSource) {
      stepSourceOptions.push({
        label: `Missing Step: ${source}`,
        value: source
      });
    }
  }

  return (
    <div>
      <div>
        <div className={"font-bold"}>{"Add Step Sources"}</div>
        <Select
          options={stepSourceOptions}
          placeholder="Select Step Sources"
          value={stepSourceOptions.filter((option) => step?.input_sources?.includes(option?.value))}
          onChange={(selectedOptions) => {
            const selectedSources = selectedOptions?.map((option) => option?.value);

            setNewStepData({ ...step, input_sources: selectedSources });
          }}
          isMulti
        />
      </div>
      <div className={"mt-[10px]"}>
        <div className={"font-bold"}>{"Step Prompt"}</div>
        <textarea
          placeholder="Prompt for this step"
          className={styles.aaTextArea}
          style={{ height: "120px", padding: "5px" }}
          value={step?.input_template}
          onChange={(val) => setNewStepData({ ...step, input_template: val.currentTarget.value })}
        />
      </div>
    </div>
  );
};

const StepCommunicationOptions = ({
  step,
  index,
  agent,
  setNewStepData,
  slackChannels,
  initialChannelTargets,
  initialSandbox
}) => {
  const executionSteps = agent?.execution_steps ?? [];
  const agentIQToolOptions = useSelector((state) => chatGPTReducer.getAgentIQToolOptions(undefined, undefined, true));
  const isSynthesisStep = step?.type === "synthesize";
  const communicationTool = step?.communication_tool;
  const hasSendMessageTool = communicationTool !== undefined && communicationTool?.id === 21;
  const hasSlackTool = isSynthesisStep && communicationTool !== undefined && communicationTool?.id === 11;

  const communicationToolOptions = agentIQToolOptions
    .filter((o) => o?.id === 21)
    .map((o) => {
      return {
        label: o?.label,
        value: o?.id
      };
    });

  if (isSynthesisStep) {
    const slackAgentTool = agentIQToolOptions.find((o) => o?.id === 11);

    communicationToolOptions.push({
      label: slackAgentTool?.label,
      value: slackAgentTool?.id
    });
  }

  const NO_COMMUNICATION_OPTION = {
    label: "None",
    value: null
  };

  const channelOptions = (initialChannelTargets ?? []).map((channel) => ({
    label: channel,
    value: channel
  }));

  const selectedCommunicationTool =
    communicationToolOptions.find((option) => option?.value === step?.communication_tool?.id) ?? null;

  const selectedChannel = channelOptions.find((option) => option?.value === communicationTool?.target) ?? null;

  if (selectedCommunicationTool !== undefined && selectedCommunicationTool !== null) {
    communicationToolOptions.unshift(NO_COMMUNICATION_OPTION);
    if (selectedChannel && selectedChannel !== null) {
      channelOptions.unshift(NO_COMMUNICATION_OPTION);
    }
  }

  const slackChannelOptions = (isSynthesisStep ? (slackChannels ?? []) : []).map((sc) => ({
    label: sc?.config?.channel_id,
    value: sc?.id
  }));

  const selectedSlackChannel =
    slackChannelOptions.find((option) => option?.value === step?.communication_tool?.third_party_tool_id) ?? null;

  return (
    <div>
      <div className={styles.synthesisSelectWrapper}>
        <div className={"font-bold"}>{"Add Communication Tools"}</div>
        <Select
          options={communicationToolOptions}
          placeholder="Select Communications Sources"
          value={selectedCommunicationTool}
          onChange={(selectedOption) => {
            if (selectedOption?.value === 21) {
              const stepUpdate = {
                ...step,
                communication_tool: { id: 21, name: "send_openclaw_message", sandbox_name: initialSandbox }
              };
              return setNewStepData(stepUpdate);
            }
            if (selectedOption?.value === 11) {
              const stepUpdate = {
                ...step,
                communication_tool: { id: 11, name: "publish_report_to_slack" }
              };
              return setNewStepData(stepUpdate);
            }
            setNewStepData({ ...step, communication_tool: { id: selectedOption.value } });
          }}
          menuPlacement={"top"}
        />
      </div>
      {hasSendMessageTool && (
        <div className={styles.synthesisSelectWrapper}>
          <div className={"font-bold"}>{"Communication Channel"}</div>
          <Select
            options={channelOptions}
            placeholder="Select Channel to send message to"
            value={selectedChannel}
            onChange={(selectedOption) => {
              const stepUpdate = {
                ...step,
                communication_tool: {
                  ...(communicationTool ?? {}),
                  target: selectedOption?.value
                }
              };

              setNewStepData(stepUpdate);
            }}
            menuPlacement={"top"}
          />
        </div>
      )}
      {hasSlackTool && (
        <div className={styles.synthesisSelectWrapper}>
          <div className={"font-bold"}>{"Slack Channel"}</div>
          <Select
            options={slackChannelOptions}
            placeholder="Select Channel to Publish Report to"
            value={selectedSlackChannel}
            onChange={(selectedOption) => {
              const stepUpdate = {
                ...step,
                communication_tool: {
                  ...(step?.communication_tool ?? {}),
                  third_party_tool_id: selectedOption?.value
                }
              };

              setNewStepData(stepUpdate);
            }}
            menuPlacement={"top"}
          />
        </div>
      )}
    </div>
  );
};


export default withRouter(AibleAnywhereBuilder);
